import HomeComponent from "../../components/Home/HomeComponent";
const Home = () => {
    return (
        <>
            <HomeComponent />
        </>
    )
}

export default Home;